export const detectDataAcquisitionType = (nodes) => {
  const pollingNodes = nodes.filter(
    (node) =>
      node.node_type === "VARIABLE" &&
      node.attributes.data_acquisition_type === "POLLING",
  );

  const monitoringNodes = nodes.filter(
    (node) =>
      node.node_type === "VARIABLE" &&
      node.attributes.data_acquisition_type === "MONITORING",
  );

  if (pollingNodes.length > 0 && monitoringNodes.length > 0) {
    return {
      type: "Mixed",
      interval: null,
    };
  }

  if (pollingNodes.length > 0) {
    const uniqueIntervals = Array.from(
      new Set(
        pollingNodes.map((node) => node.attributes.sample_interval_in_seconds),
      ),
    );
    const interval = uniqueIntervals.length === 1 ? uniqueIntervals[0] : 60;

    return {
      type: "Polling",
      interval: interval,
    };
  }

  if (monitoringNodes.length > 0) {
    return {
      type: "Monitoring",
      interval: null,
    };
  }

  return {
    type: "Mixed",
    interval: null,
  };
};
